<template>
  <div style="width: 100%; min-height: 100vh; background: #f1f1f1">
    <van-nav-bar style="position: fixed; transform: translate(-50%); top: 0; left: 50%; width: 100%;max-width: 412px; background-color: #fff" title="个人资料" left-arrow @click-left="$router.back()" />
      <div style="height: 46px"></div>
    <div class="usrse">
      <div class="hgs" style="border: 0;box-shadow: none;display: flex;align-items: center;">
        <div class="imgsa">
          <img mode="aspectFill" :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/imageAvatar02@3x.png'" alt="" />
          <input class="inputsw" type="file" @change="onchangemd" single accept="image/gif,image/png" />
          <img class="bisn" mode="aspectFill" src="/static/image/avatarEdit.cf65ea838bb7aba043f461f551f740ac.png" />
        </div>
        <div style="padding-left: 20px;">
          <p style="color: #866638;font-size: 14px;">设置</p>
          <p style="color: #999;font-size: 13px;display: flex;align-items: center;">账号：{{ $store.state.userInfo.username }} <span style="width: 6px;"></span> <svg width="1.5em" height="1.5em" @click="clickCopy($store.state.userInfo.username)" fill="#866638" class="" viewBox="0 0 20.727 24">
                <path id="4e0f559826fd31bb0ad8a4c5934c2092-comm_icon_copy" d="M1801.586,16.829a1.094,1.094,0,0,1-1.1-1.093V-1.781a1.094,1.094,0,0,1,1.1-1.093,1.094,1.094,0,0,1,1.095,1.093V14.643h13.136a1.093,1.093,0,1,1,0,2.185Zm4.305-4.3a1.1,1.1,0,0,1-1.1-1.093V-6.078a1.094,1.094,0,0,1,1.1-1.093h8.759a1.094,1.094,0,0,1,.773.32l5.474,5.463a1.091,1.091,0,0,1,.321.773V11.439a1.094,1.094,0,0,1-1.1,1.093Zm1.094-2.185h12.044V1.569h-5.474A1.094,1.094,0,0,1,1812.46.476V-4.986h-5.475Z" transform="translate(-1800.491 7.171)"></path>
              </svg></p>
        </div>
      </div>
      <p style="color: #666;padding-bottom: 10px;">默认展示信息</p>
      <div class="hgs">
        <div >
          <van-cell-group>
            <van-field v-model="$store.state.userInfo.username" placeholder="请输入用户名" disabled left-icon="manager-o"/>
          </van-cell-group>
        </div>
      </div>
      <div class="hgs">
        <div >
          <van-cell-group>
            <van-field v-model="$store.state.userInfo.realname" placeholder="请输入真实姓名" disabled left-icon="user-o"/>
          </van-cell-group>
        </div>
      </div>
      <div class="hgs" @click="changShow">
        <div >
          <van-cell-group>
            <van-field v-model="birthday" placeholder="请选择出入日期" disabled left-icon="calendar-o"/>
          </van-cell-group>
        </div>
      </div>

      <div class="hgs">
        <div >
          <van-cell-group>
            <van-field v-model="mobile" placeholder="绑定手机号，保障账号安全" left-icon="phone-circle-o"/>
          </van-cell-group>
        </div>
      </div>
      <div class="hgs">
        <div >
          <van-cell-group>
            <van-field v-model="email" placeholder="绑定邮箱保护账号安全" left-icon="free-postage"/>
          </van-cell-group>
        </div>
      </div>
      <div class="bo">
        <van-button type="info" class="bo_back"  @click="$router.go(-1)">返回</van-button>
        <van-button type="info"  class="bo_save" @click="isOk">保存</van-button>

      </div>
    </div>
    <van-datetime-picker style="position: fixed; width: 100%; bottom: 0px; left: 0; background: #f1f1f1" type="date" v-if="showPicker" :min-date="minDate" @confirm="onConfirm" @cancel="changShow" />
  </div>
</template>
<script>
export default {
  name: 'userInfo',
  data() {
    return {
      mobile: null,
      email: null,
      birthday: null,
      showPicker: false,
      minDate: new Date(1980, 0, 1),
    };
  },
  created() {
    let that = this;
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    that.mobile = userInfo.mobile;
    that.email = userInfo.email;
    that.birthday = userInfo.birthday;
  },
  methods: {
    clickCopy(text){
      let that = this
      // 创建临时的textarea
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.opacity = 0;
      document.body.appendChild(textArea);
      // 选中文本
      textArea.focus();
      textArea.select();

      try {

      // 尝试执行复制

      const successful = document.execCommand('copy');

      const msg = successful ? '成功复制到剪贴板！' : '复制失败，请手动复制！';

        that.showTost(2, msg);

      } catch (err) {

        that.showTost(2, 123);

      }

      // 移除临时元素

      document.body.removeChild(textArea);

    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    onchangemd(e) {
      let that = this;

      console.log(e.target.files); //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item); //将每一个文件图片都加进formdata
      });
      //  axios.post("接口地址", formdata).then(res => { console.log(res) })
      that.$parent.showLoading();

      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.hideLoading();

        that.$parent.getUserInfoShowLoding();
      });
    },
    timeFormat(time) {
      var time = new Date(time.getTime() + 8 * 60 * 60 * 1000);
      var myDate = time.toJSON().split('T').join(' ').substr(0, 10);
      return myDate;
    },
    changShow() {
      this.showPicker = !this.showPicker;
      console.log(123);
    },
    onConfirm(time) {
      let that = this;
      this.birthday = that.timeFormat(time);
      this.showPicker = false;
    },
    isOk() {
      let that = this;
      let info = { email: that.email, mobile: that.mobile, birthday: that.birthday };
      console.log(that.birthday);
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      let regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      let dateFormat = /^(\d{4})-(\d{2})-(\d{2})$/;
      if (!regExp.test(that.mobile)) {
        that.$parent.showTost(0, '请输入正确手机号');
        return;
      }
      if (!regEmail.test(that.email)) {
        that.$parent.showTost(0, '请输入正确邮箱号');
        return;
      }
      if (!dateFormat.test(that.birthday)) {
        that.$parent.showTost(0, '请输入正确的日期格式：YYYY-MM-DD');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun
        .post('/api/updateuserinfo', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.mobile = info.mobile;
            userInfo.email = info.email;
            userInfo.birthday = info.birthday;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$parent.getUserInfo();
            that.$parent.showTost(1, '操作成功');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    onchangemd(e) {
      let that = this;

      console.log(e.target.files); //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item); //将每一个文件图片都加进formdata
      });
      //  axios.post("接口地址", formdata).then(res => { console.log(res) })
      that.$parent.showLoading();
      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.getUserInfoShowLoding();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
// @import '../../static/css/bf324575ed6355910127.css';
.usrse {
  box-sizing: border-box;
  padding: 10px;
  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
    margin-top: 10px;
  }
  .imgsa {
    position: relative;
    height: 80px;
    // border-bottom: 1px solid #f2f2f2;
    padding-bottom: 10px;
    .bisn {
      width: 30px;
      position: absolute;
      bottom:10px;
      left: 50px;
    }
    img {
      width:75px;
      border-radius: 50%;
    }
  }
}
[class*='van-hairline']:after {
  border: none;
}

.hgs{
  margin-bottom: 14px;
  box-shadow: 0 0px 2px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  overflow: hidden;
}
.bo{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  background: #fff;
  padding: 20px 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .bo_back{
    width: 45%;
    height: 36px;
    background: #fff;
    color: #866638;
    border: 1px solid #866638;
    border-radius: 10px;
  }
  .bo_save{
width: 45%;
    height: 36px;border-radius: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/userInfo.vue